<template>
  <div>
    <div class="XVprogress-container" v-if="progressbarvisible">
      <!--progress bar with values aligned according progress bar width-->
      <div class="XVprogress-bar" :class="progressbarclass">
        <!--span waar percentage (rechts) staat-->
        <span class="XVprogress-bar-percentage XVprogress-animated" v-html="progressTarget + '%'"></span>
        <div class="XVprogress-bar-bar">
          <div
            class="XVprogress-bar-inner-bar XVprogress-animated"
            :class="[targetCalcResult === '0' ? 'progress-default' : 'progress-success']"
            :style="{ width: progressTarget + '%' }"
          ></div>
        </div>
        <!--span waar linker text in staat staat-->
        <span class="XVprogress-bar-text XVprogress-animated" v-html="progbartext"></span>
      </div>
    </div>
    <div class="XVprogresstext-container" v-if="progresstextvisible">
      <span v-html="progressbartext"></span>
      <span :class="textsucces" v-html="progressbarStateText"></span>
    </div>
  </div>
</template>


<script>
import { util } from 'pevueglobal'
export default {
  name: 'XVprogressbar',
  props: {
    nettoTarget: {
      type: Number,
    },
    normTarget: {
      type: Number,
    },
    progressTarget: {
      type: Number,
    },
    targetCalcResult: {
      // 1=groen, 0niet
      type: String,
    },
    statustextTarget: {
      type: String,
      default: '',
    },
    settingprogbar: {
      // type progress bar, setting 1 t/m 9
      type: Number,
    },
  },
  computed: {
    progbartext() {
      if (this.settingprogbar === 8) {
        return util.format2decimal(this.nettoTarget) + '/' + util.format2decimal(this.normTarget)
      } else if (this.settingprogbar === 9) {
        if (this.statustextTarget !== '') {
          return (
            util.format2decimal(this.nettoTarget) +
            '/' +
            util.format2decimal(this.normTarget) +
            ' ' +
            this.statustextTarget
          )
        } else {
          return util.format2decimal(this.nettoTarget) + '/' + util.format2decimal(this.normTarget)
        }
      } else {
        return ''
      }
    },
    progressbarvisible() {
      // Setting 7 = alleen progressbar | Setting 8 = bar+score+norm | Setting 9 = alles
      return this.settingprogbar === 7 || this.settingprogbar === 8 || this.settingprogbar === 9
    },
    progresstextvisible() {
      return (
        this.settingprogbar === 2 ||
        this.settingprogbar === 3 ||
        this.settingprogbar === 4 ||
        this.settingprogbar === 5 ||
        this.settingprogbar === 6
      )
    },
    // : text-id: 13882 = behaald, 13883 = norm
    progressbartext() {
      if (this.settingprogbar === 2) {
        return this.translation(13882) + ' ' + this.nettoTarget
      } else if (this.settingprogbar === 3) {
        return this.translation(13883) + ' ' + this.normTarget
      } else if (this.settingprogbar === 4) {
        return ''
      } else if (this.settingprogbar === 5) {
        return this.translation(13882) + ' ' + this.nettoTarget
      } else if (this.settingprogbar === 6) {
        return this.translation(13883) + ' ' + this.normTarget
      } else {
        return ''
      }
    },
    progressbarStateText() {
      if (this.settingprogbar === 4 || this.settingprogbar === 5 || this.settingprogbar === 6) {
        return this.statustextTarget
      } else {
        return ''
      }
    },
    textsucces() {
      if (this.targetCalcResult === '1') {
        return ' progresstext-success'
      } else {
        return ''
      }
    },
    progressbarclass() {
      if (this.targetCalcResult === '1') {
        return ' progressbar-success'
      } else {
        return ' progressbar-default'
      }
    },
  },
  mounted: function () {
    // adding <span> elements for value and skill name
    let progressBar = document.querySelectorAll('.XVprogress-bar')
    // function for animation toggling
    function animationToggle(progressElement, delay) {
      let skillElem = progressElement.querySelector('.XVprogress-bar-text')
      let valueElem = progressElement.querySelector('.XVprogress-bar-percentage')
      let skillBar = progressElement.querySelector('.XVprogress-bar-inner-bar')
      // removing animated classes, returning to start position
      skillElem.classList.remove('XVprogress-animated')
      valueElem.classList.remove('XVprogress-animated')
      skillBar.classList.remove('XVprogress-animated')
      // adding animated classes to start animation
      setTimeout(function () {
        skillElem.classList.add('XVprogress-animated')
        valueElem.classList.add('XVprogress-animated')
        skillBar.classList.add('XVprogress-animated')
      }, delay)
    }
    // add animation onload
    function onloadAnimation() {
      progressBar.forEach(function (item) {
        animationToggle(item, 500)
      })
    }
    onloadAnimation()
  },
}
</script>


<style>
/* progress bar styles */
.XVprogress-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 8px;
  padding-bottom: 8px;
}

.XVprogress-bar {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}
.XVprogress-bar:not(:last-child) {
  margin-bottom: 35px;
}

.XVprogress-bar--lg-offset:not(:last-child) {
  margin-bottom: 52.5px;
}

.XVprogress-bar-bar,
.XVprogress-bar-inner-bar,
.XVprogress-bar-percentage,
.XVprogress-bar-text {
  box-sizing: border-box;
}

.XVprogress-bar-bar {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.XVprogress-bar-bar--no-overflow {
  overflow: visible;
}

.XVprogress-bar-inner-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transform-origin: left center;
  transform-origin: left center;
}
.XVprogress-bar-inner-bar.XVprogress-animated {
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.1, 1.14, 0.31, 1.06);
  transition-delay: 0s;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}

.XVprogress-bar-text,
.XVprogress-bar-percentage {
  font-size: 12px;
  letter-spacing: 1px;
}

.XVprogress-bar {
  height: 20px;
  background-color: #dbdbdb;
  box-shadow: none;
}
.progressbar-default {
  color: currentColor;
}
.XVprogress-bar-inner-bar {
  background-color: #a3a3a3;
}

.XVprogress-bar-text {
  position: absolute;
  top: 50%;
  left: 10px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  opacity: 0;
}
.XVprogress-bar-text.XVprogress-animated {
  transition-property: all;
  transition-duration: 0.2s;
  transition-timing-function: linear;
  transition-delay: 0s;
  opacity: 1;
}

.XVprogress-bar-percentage {
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateX(-10px) translateX(0px) translateY(-50%);
  transform: translateX(-10px) translateX(0px) translateY(-50%);
  opacity: 0;
  z-index: 10;
}
.XVprogress-bar-percentage.XVprogress-animated {
  transition-property: all;
  transition-duration: 0.2s;
  transition-timing-function: linear;
  transition-delay: 0.45s;
  opacity: 1;
}
</style>

